module.exports = {
    name: "Northern Endurance Partnership (NEP)",
    holding: {
        brand: "/assets/images/brand.svg",
        message: "The website for the Humber Carbon Capture Pipeline (HCCP) project will go live on 9 July, in line with the launch of consultation."
    },
    base: {
        contact_address: "Eagle Tower, Montpellier Drive, Cheltenham GL50 1TA.",
        contact_number: "0800 024 1436",
        contact_email: "info@nephccp.co.uk"
    },
    meta: {
        defaultSocialImage: "/assets/images/social.jpg",
        author: "",
        description: ""
    },
    contact_form: {
        fields: [
            {
                label: "Name",
                name: "name",
                required: true,
                type: "text",
                placeholder: "Enter your full name"
            },
            {
                label: "Email",
                name: "email",
                required: true,
                type: "email",
                placeholder: "Enter your email",
            },
            {
                label: "Are you responding on behalf of an organisation?",
                name: "organisation_confirm",
                required: false,
                type: "radio",
                multiple: false, // Not required, for visual use only
                options: [
                    {
                        label: "Yes",
                        value: "yes"
                    },
                    {
                        label: "No",
                        value: "no"
                    }
                ],
            },
            {
                label: "Name of organisation?",
                name: "organisation",
                required: false,
                type: "text",
                placeholder: "Enter name of organisation",
            },
        ]
    }
};
